import React from "react";
import _ from "lodash";
import { EuiFlexItem } from "@elastic/eui";
import TripDetailsSection from "../TripDetailsSection";

export default function SupplierContractType({
    label,
    supplierContractTypeOptions,
    supplierContractTypeName,
    onChange,
    isEditable,
}) {
    return (
        <EuiFlexItem >
            <TripDetailsSection
                label={label}
                options={supplierContractTypeOptions}
                selectedValue={_.startCase(supplierContractTypeName)}
                onSelectChange={onChange}
                isEditable={isEditable}
            />
        </EuiFlexItem>
    );
}
